// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c001addd","455":"a99c3a5b","977":"0f89235d"}[chunkId] + ".chunk.js";
};